import { render, staticRenderFns } from "./ItemGrid.vue?vue&type=template&id=6b2bcf5e&scoped=true&"
import script from "./ItemGrid.vue?vue&type=script&lang=js&"
export * from "./ItemGrid.vue?vue&type=script&lang=js&"
import style0 from "./ItemGrid.vue?vue&type=style&index=0&id=6b2bcf5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2bcf5e",
  null
  
)

export default component.exports